export const INIT_USER = 'user/INIT_USER'
export const UNSET_USER = 'user/UNSET_USER'

export const initUser = payload => ({
    type: INIT_USER,
    payload,
})

export const unsetUser = () => ({
    type: UNSET_USER,
})
